
export default {
  name: "NovaVenda",

  data: () => ({
    dialog: false,
  }),

  computed: {
    vendaArmazenada() {
      return localStorage.getItem("FLEX_venda");
    },
  },

  methods: {
    novaVenda() {
      if (this.vendaArmazenada) {
        this.dialog = true;
      } else {
        this.$router.push("/vendas/produtos");
      }
    },

    confirmaNovaVenda() {
      localStorage.removeItem("FLEX_venda");
      this.$router.push("/vendas/produtos");
    },
  },
};
